import { Component, Input, OnInit } from '@angular/core';
import { DocumentosService } from '~core/api/documentos.service';
import { fieldsRotas } from '~pages/config/relatorio/config-relatorio/add-campo-dialog/const';



@Component({
  selector: 'app-relatorio-dinamico-pdf',
  templateUrl: './relatorio-dinamico-pdf.component.html',
  styleUrls: ['./relatorio-dinamico-pdf.component.scss'],
  providers: [DocumentosService],
})
export class RelatoriDinamicoPdfComponent implements OnInit {
  @Input() listaFields: typeof fieldsRotas = [];
  @Input() resumo!: { header: any; rows?: (string | number | null)[][]; };
  visitas: any[] = [];

  // Objeto que irá armazenar os dados para cada campo
  dataMap: { [key: string]: any } = {};

  constructor() { }

  ngOnInit(): void {
    const filteredFields = fieldsRotas.filter(field => this.resumo.header.includes(field.value));
    this.listaFields = this.resumo.header
      .map((headerValue: string) => filteredFields.find(field => field.value === headerValue))
      .filter((field: any) => field !== undefined);
  }

  getValue(fildValue: any) {
    return fildValue ? fildValue : "-";
  }
  
}
